import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Shield = (props: Icon): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 14 16"
    style={{ ...style(props.size, props.height), ...props.style }}
    className={props.className}
  >
    <defs>
      <path
        id="shield-a"
        d="M11.676 4.084a.667.667 0 01.648 0l6 3.333c.211.118.343.34.343.583v4.018c-.106 3.898-1.865 6.446-6.46 7.949a.667.667 0 01-.414 0c-4.595-1.503-6.354-4.05-6.46-7.967V8a.67.67 0 01.343-.583zM12 5.429L6.667 8.392v3.59c.088 3.289 1.446 5.317 5.31 6.64l.022.008.253-.088c3.615-1.298 4.941-3.256 5.075-6.351l.006-.191V8.392L12 5.429zm2.703 4.016c.285.19.376.56.224.858l-.039.067-2.667 4a.667.667 0 01-.857.224l-.067-.04-2-1.333a.667.667 0 01.672-1.148l.067.039 1.445.963L13.78 9.63a.667.667 0 01.924-.185z"
      ></path>
    </defs>
    <g
      fill={props.color || theme.palette.grey600}
      fillRule="evenodd"
      transform="translate(-5 -4)"
    >
      <mask id="shield-b" fill="#fff">
        <use xlinkHref="#shield-a"></use>
      </mask>
      <g fill={props.color || theme.palette.grey600} mask="url(#shield-b)">
        <path d="M0 0h24v24H0z"></path>
      </g>
    </g>
  </svg>
);
